import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import isEqual from "react-fast-compare";
export const GalleryViewBox = /*#__PURE__*/ memo((param)=>{
    let { box, render, index, isVisible } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "[&>*]:h-full",
        style: {
            width: box.width,
            height: box.height,
            left: box.left,
            position: "absolute"
        },
        children: render(index, isVisible)
    });
}, isEqual);
GalleryViewBox.displayName = "GalleryViewBox";
